<template>
  <div :class="['wrap', fontSize]">
    <div :style="`width: ${media_width}px; height: 100%`">
      <div class="marquee">
        <div ref="marqueeRef" class="marquee-wrap">
          <p ref="textRef" class="marquee-text">{{ getMarqueeText || '歡迎光臨' }}</p>
          <p ref="textRef2" class="marquee-text">{{ getMarqueeText || '歡迎光臨' }}</p>
        </div>
      </div>
      <div class="media">
        <div class="media-wrap" v-if="!changeList && mediaList.length > 0">
          <div
            v-for="(media, m_index) in mediaList"
            :key="m_index"
            :class="['item', index === m_index ? 'item-show' : '']"
          >
            <div v-if="media.type === 1" :class="['file-wrap', is_defaultMediaWidth ? 'fit-wrap' : '']">
              <img v-if="media.type === 1" :src="path + media.path" alt="" class="file" />
            </div>
            <div v-else class="file-wrap">
              <video :id="'video_' + m_index" class="file">
                <source :src="path + media.path" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
        <div v-else></div>
      </div>
    </div>
    <div :style="`width: ${cart_width}px; height: 100%; padding-left: 10px`">
      <div class="title-wrap">
        <p style="text-align: left">商品名稱</p>
        <p>數量</p>
        <p>金額</p>
      </div>
      <div class="cart">
        <div class="content-wrap">
          <div class="cart-content">
            <div
              v-for="(item, index) in renderCartList"
              :key="index"
              :class="['cart-item', item.form_source_code ? 'meal-item' : '', item.item_type === 0 ? '' : 'red']"
              :style="`height: ${100 / pageItem}%`"
            >
              <p class="name">{{ item.item?.label }}</p>
              <p>{{ item.quantity }}</p>
              <p>{{ item.subtotal }}</p>
              <p class="description">{{ item.description }}</p>
            </div>
          </div>
          <div class="transaction">
            <div class="item-wrap">
              <div class="item">
                <span>卡號</span>
                <span>{{ want_card }}</span>
              </div>
              <div class="item">
                <span>統編</span>
                <span>{{ tax }}</span>
              </div>
            </div>
            <div class="item-wrap">
              <div class="item">
                <span>已收</span>
                <span class="number">${{ paid }}</span>
              </div>
              <div class="item">
                <span>找零</span>
                <span class="number">${{ change }}</span>
              </div>
            </div>
          </div>
          <div class="total">
            <p>合計</p>
            <p>{{ quantity }} 項</p>
            <p>${{ total }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <new-cus-dialog v-model:visible="getMemberDialogState" width="460" :hideClose="true">
    <template #header>
      <div class="message-content__header">
        <p>請確認會員電話是否正確</p>
      </div>
    </template>
    <template #body>
      <div class="message-content__body">
        <p>
          <span
            v-for="(item, index) in getMemberPhone"
            :key="index"
            :style="{
              color: item.isDigit ? 'green' : 'gray',
              'letter-spacing': '2px',
              fontWeight: item.isDigit ? 'bold' : 'normal',
            }"
          >
            {{ item.char }}
          </span>
        </p>
      </div>
    </template>
  </new-cus-dialog>
</template>
<script>
import { computed, ref, onBeforeMount, onBeforeUnmount, nextTick, watch } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';

export default {
  name: 'guest',
  setup() {
    const gettersDialog = useGetters('websocket', ['getMemberPhoneDialogState']);
    const gettersPhone = useGetters('websocket', ['getMemberPhone']);
    const getMemberDialogState = computed(() => gettersDialog.value);
    const getMemberPhone = computed(() => gettersPhone.value);

    //取得螢幕尺寸並設定媒體寬度
    const media_width = ref(0);
    const cart_width = ref(0);
    const is_defaultMediaWidth = ref(true); //螢幕寬度是否足夠
    const getMediaWidth = () => {
      const screenHeight = document.documentElement.clientHeight;
      const screenWidth = document.documentElement.clientWidth;
      const defaultMediaWidth = ((screenHeight - 80) / 4) * 5; // 80為grid-template-rows的60px + 上下padding-20px
      if (screenWidth - defaultMediaWidth - 30 < 370) {
        media_width.value = screenWidth - 400;
        is_defaultMediaWidth.value = false;
      } else {
        media_width.value = defaultMediaWidth;
        is_defaultMediaWidth.value = true;
      }
      cart_width.value = screenWidth - media_width.value - 20;
    };
    getMediaWidth();
    onBeforeMount(() => {
      window.addEventListener('resize', getMediaWidth);
    });
    onBeforeUnmount(() => {
      window.removeEventListener('resize', getMediaWidth);
    });
    //取得螢幕尺寸設定字級大小
    const fontSize = ref(screen.width >= 1700 ? 'font-size-large' : 'font-size-normal');
    //取得資料
    const createWebSocket = useActions('websocket', ['createWebSocket']);
    createWebSocket();
    const getOrderList = useGetters('websocket', ['getOrderList']);
    const storageInfo = JSON.parse(sessionStorage.getItem('order_list'));

    const cart = computed(() => {
      console.log('getOrderList', getOrderList);
      if (getOrderList.value) return getOrderList.value.cart || [];
      else return storageInfo?.cart || [];
    });
    const total = computed(() => {
      if (getOrderList.value) return getOrderList.value.total || 0;
      else return storageInfo?.total || 0;
    });
    const quantity = computed(() => {
      if (getOrderList.value) return getOrderList.value.quantity || 0;
      else return storageInfo?.quantity || 0;
    });
    const paid = computed(() => {
      if (getOrderList.value) return getOrderList.value.paid || 0;
      else return storageInfo?.paid || 0;
    });
    const change = computed(() => {
      if (getOrderList.value) return getOrderList.value.change || 0;
      else return storageInfo?.change || 0;
    });
    const tax = computed(() => {
      if (getOrderList.value) return getOrderList.value.tax || '';
      else return storageInfo?.tax || '';
    });
    const want_card = computed(() => {
      if (getOrderList.value) return getOrderList.value.want_card || '';
      else return storageInfo?.want_card || '';
    });
    //計算購物車
    const pageItem = ref(8);
    const currentIndex = ref(cart.value ? cart.value.length : 0); // 當前更新的商品Index
    watch(
      () => cart.value,
      (newVal, oldVal) => {
        // 若已有多頁，修改前頁商品，客顯畫面亦須回到前頁給客人看
        if (newVal.length == oldVal.length) {
          for (let i = 0; i < newVal.length; i++) {
            if (JSON.stringify(newVal[i]) != JSON.stringify(oldVal[i])) {
              currentIndex.value = i + 1;
              return;
            }
          }
        } else {
          currentIndex.value = newVal.length;
        }
      }
    );
    const currentPage = computed(() => Math.ceil(currentIndex.value / pageItem.value));
    const renderCartList = computed(() =>
      cart.value?.slice((currentPage.value - 1) * pageItem.value, currentPage.value * pageItem.value)
    );
    //------------------------------------------------------------------
    //跑馬燈
    const marqueeRef = ref(null);
    const textRef = ref(null);
    const textRef2 = ref(null);
    const getMarqueeText = useGetters('system', ['getMarqueeText']);

    const marqueeInit = (async function () {
      await nextTick();
      const speed = 0.2; // 降低移動速度，從 1 改為 0.3
      let position = 0;

      // 初始化第二個文字的位置
      if (textRef2.value) {
        textRef2.value.style.left = '100%';
      }

      setInterval(() => {
        if (!textRef.value || !textRef2.value) return;

        position -= speed;

        // 設定兩個文字的位置
        textRef.value.style.left = position + '%';
        textRef2.value.style.left = position + 100 + '%';

        // 當第一個文字完全移出時，重置位置
        if (position <= -100) {
          position = 0;
          textRef.value.style.left = position + '%';
          textRef2.value.style.left = '100%';
        }
      }, 15); // 更新間隔從 15ms 改為 30ms
    })();

    //------------------------------------------------------------------
    //預設清單for空陣列使用
    const defaultMedia = [{ type: 1, path: 'ad_imgs/default.jpg' }];
    //取得清單
    const getSlideshows = useGetters('system', ['getSlideshows']);
    const getEcho = useActions('system', ['getEcho']);
    const mediaList = ref([]);
    const copy = ref([]);
    //相關參數
    const index = ref(0);
    const second = ref(5000);
    const media_type = computed(() => mediaList.value[index.value]?.type);
    const changeList = ref(false);
    //清單初始化
    const mediaInit = (async function () {
      await getEcho();
      if (getSlideshows.value.length > 0) {
        copy.value = JSON.parse(JSON.stringify(getSlideshows.value));
        mediaList.value = JSON.parse(JSON.stringify(getSlideshows.value));
      } else {
        mediaList.value = defaultMedia;
      }
      // console.log(mediaList.value);
      carousel();
    })();
    //輪播結束換清單
    const getList = () => {
      changeList.value = true;
      if (getSlideshows.value.length > 0) {
        copy.value = JSON.parse(JSON.stringify(getSlideshows.value));
        mediaList.value = JSON.parse(JSON.stringify(getSlideshows.value));
      } else {
        if (copy.value.length > 0) {
          mediaList.value = JSON.parse(JSON.stringify(copy.value));
        } else {
          mediaList.value = defaultMedia;
        }
      }
      // console.log(mediaList.value);
      return Promise.resolve();
    };
    //執行媒體
    const carousel = async () => {
      // console.log(index.value);
      if (media_type.value === 2) {
        await nextTick();
        const video = document.querySelector(`#video_${index.value}`);
        if (video) playVideo(video);
        else changeImage();
      }
      if (media_type.value === 1) {
        setTimeout(() => {
          changeImage();
        }, second.value);
      }
    };
    //輪播置換
    const changeImage = async () => {
      if (index.value === mediaList.value.length - 1) {
        index.value = 'end';
        await getList();
        changeList.value = false;
        index.value = 0;
      } else index.value += 1;
      carousel();
    };
    //影片播放
    const playVideo = (video) => {
      video.play();
      video.addEventListener('ended', changeImage);
    };
    //------------------------------------------------------------------

    return {
      media_width,
      cart_width,
      is_defaultMediaWidth,
      fontSize,
      cart,
      total,
      quantity,
      paid,
      change,
      tax,
      want_card,
      pageItem,
      renderCartList,
      marqueeRef,
      textRef,
      textRef2,
      getMarqueeText,
      marqueeInit,
      mediaList,
      mediaInit,
      index,
      changeList,
      getMemberDialogState,
      getMemberPhone,
    };
  },
  data() {
    return {
      path: process.env.VUE_APP_URL_PATH,
    };
  },
};
</script>
<style lang="scss" scoped>
$bar-height: 50px;
.wrap {
  font-family: Noto Sans TC, 微軟正黑體, Microsoft JhengHei;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: $color-gray-10;
  color: $color-brand;
  padding: 10px;
  display: -webkit-flex;
}

@mixin base-ground($bgc) {
  background-color: $bgc;
  border-radius: 8px;
}
@mixin base-title-wrap($fz, $color) {
  font-size: $fz;
  color: $color;
  height: $bar-height;
  line-height: $bar-height;
  padding: 0 16px;
}
@mixin base-cart-grid {
  text-align: right;
  display: -webkit-flex;
  flex-wrap: wrap;
  p:nth-of-type(1) {
    width: 65%;
  }
  p:nth-of-type(2) {
    width: 15%;
  }
  p:nth-of-type(3) {
    width: 20%;
  }
  p:nth-of-type(4) {
    width: 100%;
  }
}
.marquee-wrap {
  @include base-title-wrap(2.25rem, #fff);
  @include base-ground($color-brand);
  position: relative;
  overflow: hidden;
  .marquee-text {
    width: 100%;
    position: absolute;
    white-space: nowrap;
    text-align: center;
  }
}
.media {
  height: calc(100% - $bar-height - 10px);
  border-radius: 8px;
  overflow: hidden;
  margin-top: 10px;
  .media-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    .item {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      opacity: 0;
      transition: 0.5s;
    }
    .item-show {
      opacity: 1;
    }
    .file-wrap {
      width: 100%;
      height: 100%;
      background-color: rgb(54, 54, 54);
      .file {
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .fit-wrap {
      background-color: transparent;
    }
  }
}
.title-wrap {
  @include base-title-wrap(2rem, $color-brand);
  @include base-cart-grid;
  @include base-ground(#fff);
}
.cart {
  margin-top: 10px;
  height: 100%;
  .content-wrap {
    height: calc(100% - $bar-height - 10px);
  }
  .cart-content {
    height: calc(100% - 120px - $bar-height);
    @include base-ground(#fff);
    .cart-item {
      @include base-cart-grid;
      align-items: flex-end;
      padding: 0 16px;
      border-bottom: 1px solid $color-gray-10;
      p {
        font-size: 2.25rem;
      }
      .name,
      .description {
        width: 100%;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .description {
        font-size: 2rem;
        color: $color-gray-60;
        align-self: flex-start;
      }
      .text-small {
        font-size: 2.1rem;
      }
    }
    .red {
      color: $color-red;
    }
    .meal-item {
      background-color: rgba(242, 180, 0, 0.12);
    }
  }
  .transaction {
    height: 100px;
    margin-top: 10px;
    display: -webkit-flex;
    justify-content: space-between;
    font-size: 2rem;
    .item-wrap {
      width: 48.5%;
      display: -webkit-flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 10px 16px;
      @include base-ground(#fff);
      .item {
        @include flex-between-center;
      }
      .number {
        font-size: 2.25rem;
        font-weight: bold;
      }
    }
  }
  .total {
    height: $bar-height;
    margin-top: 10px;
    @include base-ground($color-brand);
    padding: 0 16px;
    color: #fff;
    display: -webkit-flex;
    align-items: center;
    p:nth-of-type(1) {
      font-size: 2.25rem;
      width: 40%;
    }
    p:nth-of-type(2) {
      font-size: 3rem;
      text-align: center;
      width: 25%;
    }
    p:nth-of-type(3) {
      font-size: 3rem;
      text-align: right;
      width: 35%;
    }
  }
}
.font-size-large {
  .marquee-wrap {
    font-size: 2.7rem;
  }
  .title-wrap {
    font-size: 2.4rem;
  }
  .cart {
    .cart-content {
      .cart-item {
        p {
          font-size: 2.8rem;
        }
        .description {
          font-size: 2.5rem;
        }
      }
    }
    .transaction {
      font-size: 2.4rem;
      .item-wrap {
        .number {
          font-size: 2.7rem;
        }
      }
    }
    .total {
      p:nth-of-type(1) {
        font-size: 2.7rem;
      }
      p:nth-of-type(2) {
        font-size: 3.3rem;
        text-align: center;
      }
      p:nth-of-type(3) {
        font-size: 3.3rem;
        text-align: right;
      }
    }
  }
}
* {
  // outline: 1px solid #000;
}
.message-content {
  &__header {
    width: 100%;
    font-size: 3rem;
    line-height: 50px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__body {
    font-size: 6rem;
    line-height: 1.25;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
